export default __webpack_public_path__ + "static/media/55.caee9765.jpeg";